import axios from "../axios-auth";
import orginal_axios from "axios";

export const balanceSheetService = {
    getBalanceSheetList,
    saveBalanceSheet,
    getBalanceSheetById,
    getBalanceSheetForPreview,
    getBalanceSheetExport,
    getExportBalanceSheetDetail
};

function getBalanceSheetForPreview(balanceSheet) {
    // preview
    return axios.post("/auth/preview-balance-sheet", balanceSheet);
}

function getBalanceSheetExport(searchParams, shopCode) {
    let params = {
    };
    if (searchParams.fromMonth) {
        params["fromMonth"] = searchParams.fromMonth;
    }
    if (searchParams.toMonth) {
        params["toMonth"] = searchParams.toMonth;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (shopCode) {
        params["shopCode"] = shopCode;
    }
    if (searchParams.balanceType) {
        params["balanceType"] = searchParams.balanceType;
    }

    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/preview-balance-sheet-export",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

function getBalanceSheetList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.code) {
        params["code"] = searchParams.code;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    return axios.get("/auth/balance-sheets", { params });
}

function saveBalanceSheet(balanceSheet) {
    if (!balanceSheet.id) {
        // new income statement
        return axios.post("/auth/balance-sheet", balanceSheet);
    } else {
        return axios.put("/auth/balance-sheet", balanceSheet);
    }
}

function getBalanceSheetById(id) {
    return axios.get("/auth/balance-sheet/" + id);
}

function getExportBalanceSheetDetail(id) {
    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/balance-sheet-export-detail/" + id,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}
